const commands = [
  {
    name: '/assign',
    requiredParameters: true,
    description: 'Adds agent to conversation',
  },
  {
    name: '/assign_primary_agent',
    description: 'Adds primary agent to conversation',
  },
  { name: '/bot',
    requiredParameters: true,
    description: 'Activates/Deactivates bot' },
  {
    name: '/category',
    requiredParameters: true,
    description: 'Assign category to conversation',
  },
  { name: '/complete', description: 'Сomplete conversation' },
  { name: '/delay', description: 'Add delay to next the action' },
  { name: '/form', description: 'Trigger configured postchat form' },
  {
    name: '/lock',
    requiredParameters: true,
    description: 'Locks conversation',
  },
  {
    name: '/lock_primary_agent',
    requiredParameters: true,
    description: 'Locks primary agent to conversation',
  },
  {
    name: '/note',
    requiredParameters: true,
    description: 'Adds note to conversation',
  },
  { name: '/send_agent_list', description: 'Send agent selection list' },
  { name: '/star', description: 'Adds conversation to watchlist' },
  {
    name: '/tag',
    requiredParameters: true,
    description: 'Assign tag to conversation',
  },
  {
    name: '/team',
    requiredParameters: true,
    description: 'Assign team to conversation',
  },
  { name: '/trigger_email_form', description: 'Trigger email form' },
  {
    name: '/unassign',
    requiredParameters: true,
    description: 'Removes agent from conversation',
  },
  { name: '/unlock', description: 'Unlocks conversation' },
  { name: '/unstar', description: 'Removes conversation from watchlist' },
  {
    name: '/unteam',
    requiredParameters: true,
    description: 'Assign team to conversation',
  },
  {
    name: '/workflow',
    requiredParameters: true,
    description: 'Run a selected workflow on conversation',
  },
];

export default commands;